import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react";
import "emoji-mart/css/emoji-mart.css";
import { useParams } from "react-router-dom";
import { getSocket } from "../../services/socket-io";
import { Picker } from "emoji-mart";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import ScheduleIcon from "@material-ui/icons/Schedule";
import Chip from "@material-ui/core/Chip";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Hidden,
  Menu,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { i18n } from "../../translate/i18n";
import { fmtDateTimeShort } from "../../translate/localeHelper";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import MetaTemplatesDrawer from "../MetaTemplatesDrawer";
import InlineTemplateSender from "../InlineTemplateSender";

let mediaRecorder = null;
let audioChunks = [];

const useStyles = makeStyles(theme => ({
  mainWrapper: {
    background: theme.palette.background.default,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },

  newMessageBox: {
    background: theme.palette.background.default,
    width: "100%",
    display: "flex",
    padding: "7px",
    alignItems: "center",
  },

  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    background: theme.palette.background.paper,
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
  },

  // feat_271: en el flotante angosto, minWidth:0 evita que el textarea se aplaste.
  messageInputWrapperCompact: {
    minWidth: 0,
    marginRight: 4,
  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    color: theme.palette.text.primary,
  },

  sendMessageIcons: {
    color: "grey",
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.background.default,
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "50px",
    background: theme.palette.background.paper,
    padding: "2px",
    border: "1px solid #CCC",
    left: 0,
    width: "100%",
    "& li": {
      listStyle: "none",
      "& a": {
        display: "block",
        padding: "8px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxHeight: "32px",
        "&:hover": {
          background: "#F1F1F1",
          cursor: "pointer",
        },
      },
    },
  },

  mediaPreviewFullscreen: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(15, 20, 25, 0.95)",
    display: "flex",
    flexDirection: "column",
    zIndex: 100,
    color: "#fff",
  },
  mediaPreviewHeader: {
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    flexShrink: 0,
  },
  mediaCloseButton: {
    color: "#fff",
  },
  mediaPreviewBody: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    color: "#fff",
    padding: "0 20px",
  },
  mediaPreviewFooter: {
    display: "flex",
    alignItems: "flex-end",
    gap: 8,
    padding: "12px 20px 16px",
    backgroundColor: "rgba(0,0,0,0.3)",
    flexShrink: 0,
  },
  mediaCaptionInput: {
    flex: 1,
    backgroundColor: "#fff",
    borderRadius: 8,
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },
  mediaSendButton: {
    backgroundColor: "#25D366",
    color: "#fff",
    width: 48,
    height: 48,
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "#1FAF52",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(37, 211, 102, 0.5)",
      color: "#fff",
    },
  },
  dragOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(37, 211, 102, 0.10)",
    border: "3px dashed #25D366",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 50,
    pointerEvents: "none",
    fontSize: 18,
    fontWeight: 600,
    color: "#25D366",
  },
  scheduledQueue: {
    width: "100%",
    padding: "6px 12px 4px",
    borderTop: "1px dashed rgba(0,0,0,0.12)",
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
    alignItems: "center",
  },
  scheduledQueueLabel: {
    fontSize: 11,
    color: "#666",
    marginRight: 4,
    display: "flex",
    alignItems: "center",
    gap: 3,
  },
  scheduleActiveIcon: {
    color: "#1FAF52",
  },
}));

const MediaPreviewContent = ({ file }) => {
  const fileUrl = useMemo(() => URL.createObjectURL(file), [file]);
  useEffect(() => {
    return () => URL.revokeObjectURL(fileUrl);
  }, [fileUrl]);

  const type = file.type || "";

  if (type.startsWith("image/")) {
    return (
      <img
        src={fileUrl}
        alt={file.name}
        style={{ maxWidth: "90%", maxHeight: "65vh", objectFit: "contain", borderRadius: 4 }}
      />
    );
  }
  if (type.startsWith("video/")) {
    return (
      <video
        src={fileUrl}
        controls
        style={{ maxWidth: "90%", maxHeight: "65vh", borderRadius: 4 }}
      />
    );
  }
  if (type.startsWith("audio/")) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
        <AudiotrackIcon style={{ fontSize: 96, opacity: 0.7 }} />
        <audio src={fileUrl} controls />
        <span style={{ opacity: 0.7, textAlign: "center", maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
      </div>
    );
  }
  if (type === "application/pdf") {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
        <PictureAsPdfIcon style={{ fontSize: 96, opacity: 0.8, color: "#ef5350" }} />
        <span style={{ fontSize: 16, fontWeight: 500, textAlign: "center", maxWidth: 400, overflow: "hidden", textOverflow: "ellipsis" }}>{file.name}</span>
        <span style={{ opacity: 0.6, fontSize: 13 }}>{(file.size / 1024 / 1024).toFixed(2)} MB</span>
      </div>
    );
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
      <InsertDriveFileIcon style={{ fontSize: 96, opacity: 0.7 }} />
      <span style={{ fontSize: 16, fontWeight: 500, textAlign: "center", maxWidth: 400, overflow: "hidden", textOverflow: "ellipsis" }}>{file.name}</span>
      <span style={{ opacity: 0.6, fontSize: 13 }}>{(file.size / 1024 / 1024).toFixed(2)} MB</span>
    </div>
  );
};

const MessageInput = ({ ticketStatus, contact, onIntervention, ticket, ticketId: ticketIdProp, compact = false, turnosSessionId = null, attendingMode = "off" }) => {
  const classes = useStyles();
  // feat_271: toolbar compacta para el chat flotante (ancho angosto). Overflow
  // ⋮ con Firmar + programado; textarea toma el resto con flex:1/minWidth:0.
  const [compactAnchor, setCompactAnchor] = useState(null);
  const { ticketId: ticketIdParam } = useParams();
  // Chat flotante (feat_269): montado fuera de la ruta del ticket → useParams
  // no trae ticketId. Fallback a la prop. Backward-compat: callers existentes
  // no pasan la prop → sigue usando el param de la ruta.
  const ticketId = ticketIdProp || ticketIdParam;

  const [medias, setMedias] = useState([]);
  const [caption, setCaption] = useState("");
  const [savedInputMessage, setSavedInputMessage] = useState("");
  const [isDraggingFile, setIsDraggingFile] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const [interventionDialogOpen, setInterventionDialogOpen] = useState(false);
  const pendingSendRef = useRef(null);
  const inputRef = useRef();
  // feat_177 — outbound typing: refs de la sesión de presencia del asesor.
  const presenceRefreshRef = useRef(null); // interval de refresh (el typing expira ~10s)
  const presenceIdleRef = useRef(null); // timeout sin teclas → paused
  const presenceActiveRef = useRef(false); // hay un composing/recording activo
  const [anchorEl, setAnchorEl] = useState(null);
  const [metaWindowExpired, setMetaWindowExpired] = useState(false);
  const [templateDrawerOpen, setTemplateDrawerOpen] = useState(false);
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);

  const [signMessage, setSignMessage] = useLocalStorage("signOption", true);
  const [includeName, setIncludeName] = useLocalStorage("signOptionIncludeName", true);
  const [signatureResolution, setSignatureResolution] = useState({
    shouldSign: null, signaturePreferOn: null, locked: false, lockReason: null, signatureText: ""
  });

  // Scheduled message mode
  const [scheduleMode, setScheduleMode] = useState(false);
  const [scheduledQueue, setScheduledQueue] = useState([]);
  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);
  const [scheduledFor, setScheduledFor] = useState("");
  const [scheduleCancelOnReply, setScheduleCancelOnReply] = useState(true);

  const MAX_SCHEDULED_BATCH = 4;

  // ─── Ventana de 24hs de Meta (FASE B/C) ──────────────────────────────────
  // localInboundAt: timestamp del último inbound recibido en vivo por socket,
  // para reabrir la ventana al instante cuando el cliente responde (sin esperar
  // refetch del ticket). Se combina con ticket.lastCustomerMessageAt.
  const [localInboundAt, setLocalInboundAt] = useState(0);
  const META_PROVIDERS = useMemo(() => new Set(["meta", "meta_coexistence"]), []);
  const WINDOW_MS = 24 * 60 * 60 * 1000;
  const activeWhatsappId = ticket?.whatsappId;
  const isMetaTicket = META_PROVIDERS.has(ticket?.whatsapp?.provider);
  // Ventana 24hs ESTRICTA: la base SIEMPRE es un inbound real del cliente en ESTA
  // misma línea (lastCustomerMessageWhatsappId === activeWhatsappId). Si el último
  // inbound fue por otra línea (ej. QR) o no hubo inbound → base 0 → cerrada.
  // NUNCA se usa `now` como base.
  const sameLineInbound =
    ticket?.lastCustomerMessageWhatsappId != null &&
    Number(ticket.lastCustomerMessageWhatsappId) === Number(activeWhatsappId);
  const baseCustomerAt =
    sameLineInbound && ticket?.lastCustomerMessageAt
      ? new Date(ticket.lastCustomerMessageAt).getTime()
      : 0;
  // localInboundAt solo se setea para inbounds en la línea activa (ver socket abajo).
  const lastCustomerAt = Math.max(baseCustomerAt, localInboundAt);
  const metaWindowOpen = isMetaTicket
    ? lastCustomerAt > 0 && lastCustomerAt + WINDOW_MS > Date.now()
    : true;
  // Bloqueo proactivo: conexión Meta + ventana cerrada + ticket abierto.
  const metaWindowClosed = isMetaTicket && !metaWindowOpen && ticketStatus === "open";

  // feat_295: soft-lock de escritura ("EN ATENCIÓN POR <asesor>"). Solo en modo
  // "lock", sobre ticket open de OTRO asesor, y para no-admin. El candado real
  // es el guard backend en MessageController.store; esto es UX.
  // Fase 2 hook: cuando exista collaborativeQueues=true el lock se ignora
  // (default false hoy → hardcodeado; Fase 2 leerá el setting real).
  const collaborativeQueues = false; // Fase 2 hook
  const attendedByOther =
    attendingMode === "lock" &&
    !collaborativeQueues &&
    ticketStatus === "open" &&
    ticket?.userId &&
    user?.id &&
    ticket.userId !== user.id &&
    user?.profile !== "admin";
  const attendingByName = ticket?.user?.name || "";

  // Reset del override al cambiar de ticket O de línea de salida.
  useEffect(() => {
    setLocalInboundAt(0);
    setMetaWindowExpired(false);
  }, [ticketId, activeWhatsappId]);

  // Socket: reabrir la ventana al instante cuando entra un inbound del cliente
  // POR LA LÍNEA ACTIVA (un inbound por otra conexión no abre la ventana de esta).
  useEffect(() => {
    if (!ticketId) return undefined;
    // SINGLETON getSocket() + join inmediato + re-join en connect + cleanup con off.
    // NUNCA openSocket()+disconnect() (socket multiplexado v3, ver ChatConnectionBar).
    const socket = getSocket();
    socket.emit("joinChatBox", ticketId);
    const handleReconnect = () => socket.emit("joinChatBox", ticketId);
    const handleAppMessage = (data) => {
      if (
        data.action === "create" &&
        String(data.ticket?.id) === String(ticketId) &&
        data.message?.fromMe === false &&
        Number(data.ticket?.whatsappId) === Number(activeWhatsappId)
      ) {
        setLocalInboundAt(Date.now());
      }
    };
    socket.on("connect", handleReconnect);
    socket.on("appMessage", handleAppMessage);
    return () => {
      socket.off("connect", handleReconnect);
      socket.off("appMessage", handleAppMessage);
    };
  }, [ticketId, activeWhatsappId]);

  useEffect(() => {
    inputRef.current.focus();
  }, [replyingMessage]);

  // Query /signature/resolve when ticket changes to set initial switch state
  useEffect(() => {
    if (!ticketId || !user?.signatureEnabled) return;
    const fetchResolution = async () => {
      try {
        const { data } = await api.get(`/signature/resolve?ticketId=${ticketId}&excludeName=${includeName ? "false" : "true"}`);
        setSignatureResolution(data);
        if (data.locked && data.shouldSign !== null) {
          setSignMessage(data.shouldSign);
        } else if (data.signaturePreferOn !== null) {
          setSignMessage(data.signaturePreferOn);
        }
      } catch (_) {
        // Silent fallback — chat must keep working even if resolve fails
      }
    };
    fetchResolution();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketId]);

  useEffect(() => {
    const savedDraft = localStorage.getItem(`draft_${ticketId}`);
    if (savedDraft) setInputMessage(savedDraft);
    inputRef.current.focus();
    return () => {
      setInputMessage("");
      setShowEmoji(false);
      setMedias([]);
      setReplyingMessage(null);
      // NOTE: intentionally NOT removing localStorage draft here —
      // it is only removed after a successful send in handleSendMessage.
    };
  }, [ticketId, setReplyingMessage]);

  // feat_177 — outbound typing: emite la presencia del asesor al backend
  // (socket "operatorPresence" → SendOperatorPresence de feat_176). El backend
  // throttlea (≥4s) y respeta el setting outboundTypingEnabled; acá solo timing
  // + cleanup. Usa el SINGLETON getSocket() (NO el openSocket() efímero que se
  // disconnecta en cleanup). Fail-safe: nunca rompe el chat.
  const PRESENCE_REFRESH_MS = 8000; // el indicador expira ~10s en WhatsApp
  const PRESENCE_IDLE_MS = 4000; // sin teclas → paused

  const emitPresence = useCallback(
    state => {
      try {
        if (!ticketId) return;
        getSocket().emit("operatorPresence", { ticketId, state });
      } catch (_) {
        // never break the chat over a presence emit
      }
    },
    [ticketId]
  );

  const stopPresence = useCallback(
    (emitPaused = true) => {
      if (presenceRefreshRef.current) {
        clearInterval(presenceRefreshRef.current);
        presenceRefreshRef.current = null;
      }
      if (presenceIdleRef.current) {
        clearTimeout(presenceIdleRef.current);
        presenceIdleRef.current = null;
      }
      if (presenceActiveRef.current && emitPaused) emitPresence("paused");
      presenceActiveRef.current = false;
    },
    [emitPresence]
  );

  // Arranca una sesión de presencia (composing/recording) con refresh periódico.
  // Anti-spam: emite 1 vez al activarse; después solo el interval refresca.
  const startPresence = useCallback(
    state => {
      if (presenceActiveRef.current) return;
      presenceActiveRef.current = true;
      emitPresence(state);
      presenceRefreshRef.current = setInterval(
        () => emitPresence(state),
        PRESENCE_REFRESH_MS
      );
    },
    [emitPresence]
  );

  // Cleanup: al cambiar de ticket o desmontar → paused + limpiar timers. La
  // closure captura el ticketId que se está abandonando (correcto: para ese chat).
  useEffect(() => {
    return () => stopPresence(true);
  }, [ticketId, stopPresence]);

  const handleChangeInput = e => {
    const value = e.target.value; // capturar antes de setState (evento se nulifica)
    setInputMessage(value);
    localStorage.setItem(`draft_${ticketId}`, value);
    handleLoadQuickAnswer(value);

    // outbound typing: "composing" mientras hay texto; idle 4s o vacío → paused.
    if (value.trim() !== "") {
      startPresence("composing");
      if (presenceIdleRef.current) clearTimeout(presenceIdleRef.current);
      presenceIdleRef.current = setTimeout(
        () => stopPresence(true),
        PRESENCE_IDLE_MS
      );
    } else {
      stopPresence(true);
    }
  };

  const handleQuickAnswersClick = value => {
    setInputMessage(value);
    setTypeBar(false);
  };

  const handleAddEmoji = e => {
    let emoji = e.native;
    setInputMessage(prevState => prevState + emoji);
  };

  const handleNewMedia = file => {
    setSavedInputMessage(inputMessage || "");
    setInputMessage("");
    setCaption(inputMessage || "");
    setMedias([file]);
  };

  const handleChangeMedias = e => {
    if (!e.target.files) return;
    const file = e.target.files[0];
    if (file) handleNewMedia(file);
  };

  const handleInputPaste = e => {
    if (e.clipboardData.files[0]) {
      handleNewMedia(e.clipboardData.files[0]);
    }
  };

  const handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.types && e.dataTransfer.types.includes("Files")) {
      setIsDraggingFile(true);
    }
  };

  const handleDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingFile(false);
  };

  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingFile(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleNewMedia(e.dataTransfer.files[0]);
    }
  };

  const handleCancelMedia = () => {
    setMedias([]);
    setCaption("");
    setInputMessage(savedInputMessage);
    setSavedInputMessage("");
  };

  const handleUploadMedia = async () => {
    if (loading) return;
    setLoading(true);

    const trimmedCaption = (caption || "").trim();

    const formData = new FormData();
    formData.append("fromMe", true);
    medias.forEach(media => {
      formData.append("medias", media);
      formData.append("body", trimmedCaption);
      formData.append("applySignature", trimmedCaption ? String(signMessage) : "false");
      formData.append("excludeNameFromSignature", includeName ? "false" : "true");
    });
    // feat_273: modo turnos → el backend marca senderType turnos-advisor + extiende sesión.
    if (turnosSessionId) formData.append("turnosSessionId", String(turnosSessionId));

    try {
      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMedias([]);
    setCaption("");
    setSavedInputMessage("");
  };

  const handleConfirmIntervention = async () => {
    setInterventionDialogOpen(false);
    if (onIntervention) onIntervention();
    pendingSendRef.current = { bypass: true };
    handleSendMessage();
    // Clear aiStatus + set humanIntervention atomically via the correct route
    try {
      await api.put(`/contacts/${contact.id}/ai-status`, { aiStatus: null });
    } catch (err) {
      console.error("[intervention] failed to clear aiStatus:", err);
    }
  };

  const handleSendMessage = async () => {
    if (inputMessage.trim() === "") return;

    // feat_177 — el mensaje saliente ya corta el typing en WhatsApp; limpiamos
    // el estado local de presencia (cubre envío real, schedule y diálogo IA).
    stopPresence(true);

    // Ventana Meta cerrada: no se puede mandar texto libre → forzar el flujo de plantilla.
    if (metaWindowClosed) {
      setMetaWindowExpired(true);
      return;
    }

    // In schedule mode: add to queue instead of sending
    if (scheduleMode) {
      if (scheduledQueue.length >= MAX_SCHEDULED_BATCH) {
        toastError({ response: { data: { message: i18n.t("scheduledMessages.max_reached") } } });
        return;
      }
      const trimmed = inputMessage.trim();
      setScheduledQueue(prev => [...prev, { body: trimmed, quotedMsgId: replyingMessage?.id || null }]);
      setInputMessage("");
      localStorage.removeItem(`draft_${ticketId}`);
      setReplyingMessage(null);
      return;
    }

    if (contact?.aiStatus === "attending" && !contact?.humanIntervention && !pendingSendRef.current?.bypass) {
      pendingSendRef.current = null;
      setInterventionDialogOpen(true);
      return;
    }
    pendingSendRef.current = null;

    setLoading(true);

    // Capturar el body ANTES de limpiar el input
    const bodyToSend = inputMessage.trim();

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: bodyToSend,
      quotedMsg: replyingMessage,
      applySignature: signMessage,
      excludeNameFromSignature: !includeName,
      ...(turnosSessionId ? { turnosSessionId } : {}),
    };

    // Liberar el input INMEDIATAMENTE (patrón optimista estilo WhatsApp):
    // el usuario recupera el control sin esperar el round-trip de red.
    setInputMessage("");
    setShowEmoji(false);
    setReplyingMessage(null);
    localStorage.removeItem(`draft_${ticketId}`);

    try {
      await api.post(`/messages/${ticketId}`, message);
      setMetaWindowExpired(false);
    } catch (err) {
      const errKey = err.response?.data?.message?.split(":")[0];
      if (errKey === "ERR_META_WINDOW_EXPIRED") {
        setMetaWindowExpired(true);
      }
      // Restaurar el texto para que el usuario no lo pierda ante un error.
      setInputMessage(bodyToSend);
      toastError(err);
    }

    setLoading(false);
  };

  const handleToggleScheduleMode = () => {
    if (scheduleMode) {
      setScheduleMode(false);
      setScheduledQueue([]);
    } else {
      setScheduleMode(true);
    }
  };

  const handleScheduledSend = async () => {
    if (!scheduledFor) {
      toastError({ response: { data: { message: i18n.t("scheduledMessages.pick_datetime") } } });
      return;
    }
    // 60s margin: input value is local time; require > now + 60s
    const target = new Date(scheduledFor).getTime();
    if (isNaN(target) || target <= Date.now() + 60_000) {
      toastError({ response: { data: { message: i18n.t("scheduledMessages.invalid_past") } } });
      return;
    }
    setLoading(true);
    try {
      await api.post(`/scheduled-messages/${ticketId}`, {
        messages: scheduledQueue,
        scheduledFor,
        applySignature: signMessage,
        excludeName: !includeName,
        cancelOnReply: scheduleCancelOnReply,
      });
      setScheduleDialogOpen(false);
      setScheduleMode(false);
      setScheduledQueue([]);
      setScheduledFor("");
      // Immediate refresh — does not wait for socket round-trip
      window.dispatchEvent(new CustomEvent(`scheduledMessagesRefresh:${ticketId}`));
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mimeType = MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
        ? "audio/webm;codecs=opus"
        : "audio/webm";
      audioChunks = [];
      mediaRecorder = new MediaRecorder(stream, { mimeType });
      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunks.push(e.data);
      };
      mediaRecorder.start();
      setRecording(true);
      setLoading(false);
      // feat_177 — emitir "recording" SOLO tras start exitoso (mic denegado → no emite).
      startPresence("recording");
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleLoadQuickAnswer = async value => {
    if (value && value.indexOf("/") === 0) {
      try {
        const { data } = await api.get("/quickAnswers/", {
          params: { searchParam: inputMessage.substring(1) },
        });
        setQuickAnswer(data.quickAnswers);
        if (data.quickAnswers.length > 0) {
          setTypeBar(true);
        } else {
          setTypeBar(false);
        }
      } catch (err) {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
  };

  const handleUploadAudio = async () => {
    setLoading(true);
    stopPresence(true); // feat_177 — corta "grabando audio..." al enviar
    try {
      if (!mediaRecorder) throw new Error("Recorder not available");
      await new Promise((resolve) => {
        mediaRecorder.onstop = resolve;
        mediaRecorder.stop();
        mediaRecorder.stream.getTracks().forEach(t => t.stop());
      });
      const mimeType = mediaRecorder.mimeType || "audio/webm";
      const blob = new Blob(audioChunks, { type: mimeType });
      if (blob.size < 1000) {
        setLoading(false);
        setRecording(false);
        return;
      }
      const ext = mimeType.includes("ogg") ? "ogg" : "webm";
      const filename = `${new Date().getTime()}.${ext}`;
      const formData = new FormData();
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);
      if (turnosSessionId) formData.append("turnosSessionId", String(turnosSessionId));
      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }
    mediaRecorder = null;
    audioChunks = [];
    setRecording(false);
    setLoading(false);
  };

  const handleCancelAudio = async () => {
    stopPresence(true); // feat_177 — corta "grabando audio..." al cancelar
    try {
      if (mediaRecorder && mediaRecorder.state !== "inactive") {
        mediaRecorder.stop();
        mediaRecorder.stream.getTracks().forEach(t => t.stop());
      }
    } catch (err) {
      toastError(err);
    }
    mediaRecorder = null;
    audioChunks = [];
    setRecording(false);
  };

  const handleOpenMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = event => {
    setAnchorEl(null);
  };

  const renderReplyingMessage = message => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.contact?.name || message.contact?.whatsappName}
              </span>
            )}
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading || ticketStatus !== "open"}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  // Chats de sistema (contacto isSystem, ej. "🔔 Alertas Propiedades"): canal de
  // avisos automáticos sin conexión WhatsApp → input read-only, sin botón enviar.
  // Genérico: cualquier contacto isSystem, no acoplado a MatchProp.
  if (contact?.isSystem) {
    return (
      <Paper square elevation={0} className={classes.mainWrapper}>
        <div
          style={{
            padding: "14px 18px",
            textAlign: "center",
            color: "gray",
            fontSize: 13,
          }}
        >
          {i18n.t("chatInput.systemChannelReadOnly")}
        </div>
      </Paper>
    );
  }

  // feat_295: soft-lock — ticket en atención por otro asesor (modo "lock").
  // Reemplaza el input por un cartel read-only. El candado real es backend.
  if (attendedByOther) {
    return (
      <Paper square elevation={0} className={classes.mainWrapper}>
        <div
          style={{
            padding: "14px 18px",
            textAlign: "center",
            color: "#e65100",
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          {i18n.t("ticketAttending.locked", {
            name: attendingByName || i18n.t("ticketAttending.someone"),
          })}
        </div>
      </Paper>
    );
  }

  if (medias.length > 0)
    return (
      <Paper elevation={0} square className={classes.mediaPreviewFullscreen}>
        <div className={classes.mediaPreviewHeader}>
          <IconButton
            aria-label="cancel-upload"
            onClick={handleCancelMedia}
            className={classes.mediaCloseButton}
            disabled={loading}
          >
            <CancelIcon />
          </IconButton>
        </div>

        <div className={classes.mediaPreviewBody}>
          {loading ? (
            <CircularProgress className={classes.circleLoading} />
          ) : (
            <MediaPreviewContent file={medias[0]} />
          )}
        </div>

        <div className={classes.mediaPreviewFooter}>
          <TextField
            variant="outlined"
            multiline
            maxRows={4}
            fullWidth
            autoFocus
            value={caption}
            onChange={e => setCaption(e.target.value)}
            onKeyDown={e => {
              if (loading) return;
              if (e.key === "Escape") {
                e.preventDefault();
                handleCancelMedia();
                return;
              }
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleUploadMedia();
              }
            }}
            placeholder={i18n.t("messagesInput.captionPlaceholder")}
            className={classes.mediaCaptionInput}
            disabled={loading}
            size="small"
          />
          <IconButton
            aria-label="send-upload"
            onClick={handleUploadMedia}
            disabled={loading}
            className={classes.mediaSendButton}
          >
            <SendIcon />
          </IconButton>
        </div>
      </Paper>
    );
  else {
    return (
      <>
      {(metaWindowExpired || metaWindowClosed) && (
        <>
          <MetaTemplatesDrawer
            open={templateDrawerOpen}
            onClose={() => setTemplateDrawerOpen(false)}
            whatsapp={ticket?.whatsapp || (ticket?.whatsappId ? { id: ticket.whatsappId } : null)}
          />
          {ticket?.whatsappId && (
            <InlineTemplateSender
              ticket={ticket}
              contact={contact}
              companyName={user?.company?.name || ""}
              onCreate={() => setTemplateDrawerOpen(true)}
            />
          )}
        </>
      )}
      <Paper
        square
        elevation={0}
        className={classes.mainWrapper}
        onDragOver={ticketStatus === "open" ? handleDragOver : undefined}
        onDragLeave={ticketStatus === "open" ? handleDragLeave : undefined}
        onDrop={ticketStatus === "open" ? handleDrop : undefined}
        style={{ position: "relative" }}
      >
        {isDraggingFile && (
          <div className={classes.dragOverlay}>
            {i18n.t("messagesInput.dropFileHere")}
          </div>
        )}
        {replyingMessage && renderReplyingMessage(replyingMessage)}
        {scheduleMode && scheduledQueue.length > 0 && (
          <div className={classes.scheduledQueue}>
            <span className={classes.scheduledQueueLabel}>
              <ScheduleIcon style={{ fontSize: 14 }} />
              {i18n.t("scheduledMessages.queue_hint")}:
            </span>
            {scheduledQueue.map((m, idx) => (
              <Chip
                key={idx}
                size="small"
                label={m.body.length > 40 ? m.body.substring(0, 37) + "…" : m.body}
                onDelete={() => setScheduledQueue(prev => prev.filter((_, i) => i !== idx))}
              />
            ))}
          </div>
        )}
        <div className={classes.newMessageBox}>
          {compact && (
            <>
              <IconButton
                aria-label="emojiPicker"
                component="span"
                size="small"
                disabled={loading || recording || ticketStatus !== "open"}
                onClick={e => setShowEmoji(prevState => !prevState)}
              >
                <MoodIcon className={classes.sendMessageIcons} />
              </IconButton>
              {showEmoji ? (
                <div className={classes.emojiBox}>
                  <ClickAwayListener onClickAway={e => setShowEmoji(false)}>
                    <Picker
                      perLine={16}
                      showPreview={false}
                      showSkinTones={false}
                      onSelect={handleAddEmoji}
                    />
                  </ClickAwayListener>
                </div>
              ) : null}
              <input
                multiple
                type="file"
                id="upload-button"
                disabled={loading || recording || ticketStatus !== "open"}
                className={classes.uploadInput}
                onChange={handleChangeMedias}
              />
              <label htmlFor="upload-button">
                <IconButton
                  aria-label="upload"
                  component="span"
                  size="small"
                  disabled={loading || recording || ticketStatus !== "open"}
                >
                  <AttachFileIcon className={classes.sendMessageIcons} />
                </IconButton>
              </label>
              <IconButton
                aria-label="compactOverflow"
                size="small"
                disabled={loading || recording || ticketStatus !== "open"}
                onClick={e => setCompactAnchor(e.currentTarget)}
              >
                <MoreVert className={classes.sendMessageIcons} />
              </IconButton>
              <Menu
                keepMounted
                anchorEl={compactAnchor}
                open={Boolean(compactAnchor)}
                onClose={() => setCompactAnchor(null)}
              >
                <MenuItem>
                  <FormControlLabel
                    style={{ marginRight: 7, color: "gray" }}
                    label={i18n.t("messagesInput.signMessage")}
                    labelPlacement="start"
                    control={
                      <Switch
                        size="small"
                        checked={signMessage}
                        onChange={e => {
                          if (signatureResolution.locked) return;
                          setSignMessage(e.target.checked);
                        }}
                        disabled={signatureResolution.locked}
                        color="primary"
                      />
                    }
                  />
                </MenuItem>
                {signMessage && user?.signatureShowName !== false && (
                  <MenuItem>
                    <FormControlLabel
                      style={{ marginRight: 7, color: "gray" }}
                      label={i18n.t("messagesInput.includeName")}
                      labelPlacement="start"
                      control={
                        <Switch
                          size="small"
                          checked={includeName}
                          onChange={e => setIncludeName(e.target.checked)}
                          color="primary"
                        />
                      }
                    />
                  </MenuItem>
                )}
                {ticketStatus === "open" && (
                  <MenuItem
                    onClick={() => {
                      handleToggleScheduleMode();
                      setCompactAnchor(null);
                    }}
                  >
                    <ScheduleIcon
                      fontSize="small"
                      className={scheduleMode ? classes.scheduleActiveIcon : classes.sendMessageIcons}
                      style={{ marginRight: 8 }}
                    />
                    {i18n.t("scheduledMessages.mode_button")}
                  </MenuItem>
                )}
              </Menu>
            </>
          )}
          {!compact && (
          <>
          <Hidden only={["sm", "xs"]}>
            <IconButton
              aria-label="emojiPicker"
              component="span"
              disabled={loading || recording || ticketStatus !== "open"}
              onClick={e => setShowEmoji(prevState => !prevState)}
            >
              <MoodIcon className={classes.sendMessageIcons} />
            </IconButton>
            {showEmoji ? (
              <div className={classes.emojiBox}>
                <ClickAwayListener onClickAway={e => setShowEmoji(false)}>
                  <Picker
                    perLine={16}
                    showPreview={false}
                    showSkinTones={false}
                    onSelect={handleAddEmoji}
                  />
                </ClickAwayListener>
              </div>
            ) : null}

            <input
              multiple
              type="file"
              id="upload-button"
              disabled={loading || recording || ticketStatus !== "open"}
              className={classes.uploadInput}
              onChange={handleChangeMedias}
            />
            <label htmlFor="upload-button">
              <IconButton
                aria-label="upload"
                component="span"
                disabled={loading || recording || ticketStatus !== "open"}
              >
                <AttachFileIcon className={classes.sendMessageIcons} />
              </IconButton>
            </label>
            <Box style={{ display: "flex", flexDirection: "column", marginRight: 6, gap: 0 }}>
              <FormControlLabel
                style={{ color: "gray", margin: 0, height: 22 }}
                label={<Typography variant="caption">{i18n.t("messagesInput.signMessage")}</Typography>}
                labelPlacement="start"
                title={signatureResolution.locked && signatureResolution.lockReason
                  ? i18n.t(`messagesInput.lockReason.${signatureResolution.lockReason}`, i18n.t("messagesInput.lockReason.company_disabled"))
                  : ""}
                control={
                  <Switch
                    size="small"
                    checked={signMessage}
                    onChange={e => {
                      if (signatureResolution.locked) return;
                      setSignMessage(e.target.checked);
                    }}
                    disabled={signatureResolution.locked}
                    name="showAllTickets"
                    color="primary"
                  />
                }
              />
              {signMessage && user?.signatureShowName !== false && (
                <FormControlLabel
                  style={{ color: "gray", margin: 0, height: 22 }}
                  label={<Typography variant="caption">{i18n.t("messagesInput.includeName")}</Typography>}
                  labelPlacement="start"
                  control={
                    <Switch
                      size="small"
                      checked={includeName}
                      onChange={e => setIncludeName(e.target.checked)}
                      color="primary"
                    />
                  }
                />
              )}
            </Box>
          </Hidden>
          <Hidden only={["md", "lg", "xl"]}>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleOpenMenuClick}
            >
              <MoreVert></MoreVert>
            </IconButton>
            <Menu
              id="simple-menu"
              keepMounted
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuItemClick}
            >
              <MenuItem onClick={handleMenuItemClick}>
                <IconButton
                  aria-label="emojiPicker"
                  component="span"
                  disabled={loading || recording || ticketStatus !== "open"}
                  onClick={e => setShowEmoji(prevState => !prevState)}
                >
                  <MoodIcon className={classes.sendMessageIcons} />
                </IconButton>
              </MenuItem>
              <MenuItem onClick={handleMenuItemClick}>
                <input
                  multiple
                  type="file"
                  id="upload-button"
                  disabled={loading || recording || ticketStatus !== "open"}
                  className={classes.uploadInput}
                  onChange={handleChangeMedias}
                />
                <label htmlFor="upload-button">
                  <IconButton
                    aria-label="upload"
                    component="span"
                    disabled={loading || recording || ticketStatus !== "open"}
                  >
                    <AttachFileIcon className={classes.sendMessageIcons} />
                  </IconButton>
                </label>
              </MenuItem>
              <MenuItem onClick={handleMenuItemClick}>
                <FormControlLabel
                  style={{ marginRight: 7, color: "gray" }}
                  label={i18n.t("messagesInput.signMessage")}
                  labelPlacement="start"
                  control={
                    <Switch
                      size="small"
                      checked={signMessage}
                      onChange={e => {
                        if (signatureResolution.locked) return;
                        setSignMessage(e.target.checked);
                      }}
                      disabled={signatureResolution.locked}
                      name="showAllTickets"
                      color="primary"
                    />
                  }
                />
              </MenuItem>
              {signMessage && user?.signatureShowName !== false && (
                <MenuItem onClick={handleMenuItemClick}>
                  <FormControlLabel
                    style={{ marginRight: 7, color: "gray" }}
                    label={i18n.t("messagesInput.includeName")}
                    labelPlacement="start"
                    control={
                      <Switch
                        size="small"
                        checked={includeName}
                        onChange={e => setIncludeName(e.target.checked)}
                        color="primary"
                      />
                    }
                  />
                </MenuItem>
              )}
            </Menu>
          </Hidden>
          </>
          )}
          <div className={`${classes.messageInputWrapper}${compact ? " " + classes.messageInputWrapperCompact : ""}`}>
            <InputBase
              inputRef={input => {
                input && input.focus();
                input && (inputRef.current = input);
              }}
              className={classes.messageInput}
              placeholder={
                metaWindowClosed
                  ? i18n.t("messagesInput.metaWindowClosedPlaceholder")
                  : ticketStatus === "open"
                  ? i18n.t("messagesInput.placeholderOpen")
                  : i18n.t("messagesInput.placeholderClosed")
              }
              multiline
              maxRows={5}
              value={inputMessage}
              onChange={handleChangeInput}
              disabled={recording || metaWindowClosed}
              inputProps={{ readOnly: ticketStatus !== "open" || metaWindowClosed }}
              onPaste={e => {
                ticketStatus === "open" && handleInputPaste(e);
              }}
              onKeyPress={e => {
                if (e.shiftKey) return;
                else if (e.key === "Enter") {
                  e.preventDefault();
                  handleSendMessage();
                }
              }}
            />
            {typeBar ? (
              <ul className={classes.messageQuickAnswersWrapper}>
                {quickAnswers.map((value, index) => {
                  return (
                    <li
                      className={classes.messageQuickAnswersWrapperItem}
                      key={index}
                    >
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a onClick={() => handleQuickAnswersClick(value.message)}>
                        {value.category && value.category !== "General" && (
                          <span style={{ fontSize: 10, color: "#667eea", marginRight: 4, fontWeight: 600 }}>
                            [{value.category}]
                          </span>
                        )}
                        {`${value.shortcut} - ${value.message}`}
                      </a>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div></div>
            )}
          </div>
          {ticketStatus === "open" && !compact && (
            <IconButton
              aria-label="scheduleMessage"
              component="span"
              disabled={loading || recording}
              onClick={handleToggleScheduleMode}
              title={i18n.t("scheduledMessages.mode_button")}
            >
              <ScheduleIcon className={scheduleMode ? classes.scheduleActiveIcon : classes.sendMessageIcons} />
            </IconButton>
          )}
          {scheduleMode && scheduledQueue.length > 0 && !inputMessage.trim() ? (
            <IconButton
              aria-label="sendScheduledBatch"
              component="span"
              disabled={loading}
              onClick={() => setScheduleDialogOpen(true)}
              title={i18n.t("scheduledMessages.mode_button")}
            >
              <SendIcon style={{ color: "#1FAF52" }} />
            </IconButton>
          ) : inputMessage.trim() ? (
            <IconButton
              aria-label="sendMessage"
              component="span"
              onClick={handleSendMessage}
              disabled={loading}
            >
              <SendIcon className={classes.sendMessageIcons} />
            </IconButton>
          ) : recording ? (
            <div className={classes.recorderWrapper}>
              <IconButton
                aria-label="cancelRecording"
                component="span"
                fontSize="large"
                disabled={loading}
                onClick={handleCancelAudio}
              >
                <HighlightOffIcon className={classes.cancelAudioIcon} />
              </IconButton>
              {loading ? (
                <div>
                  <CircularProgress className={classes.audioLoading} />
                </div>
              ) : (
                <RecordingTimer />
              )}

              <IconButton
                aria-label="sendRecordedAudio"
                component="span"
                onClick={handleUploadAudio}
                disabled={loading}
              >
                <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
              </IconButton>
            </div>
          ) : (
            <IconButton
              aria-label="showRecorder"
              component="span"
              disabled={loading || ticketStatus !== "open"}
              onClick={handleStartRecording}
            >
              <MicIcon className={classes.sendMessageIcons} />
            </IconButton>
          )}
        </div>
      </Paper>

      <Dialog open={interventionDialogOpen} onClose={() => setInterventionDialogOpen(false)}>
        <DialogTitle>Contacto atendido por IA</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Este contacto está siendo atendido por IA.
            ¿Querés intervenir y tomar el control?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInterventionDialogOpen(false)} color="default">
            Cancelar
          </Button>
          <Button onClick={handleConfirmIntervention} color="primary" variant="contained">
            Intervenir
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={scheduleDialogOpen} onClose={() => setScheduleDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ScheduleIcon />
            {i18n.t("scheduledMessages.mode_button")}
          </span>
        </DialogTitle>
        <DialogContent style={{ display: "flex", flexDirection: "column", gap: 16, paddingTop: 8 }}>
          <Typography variant="body2" color="textSecondary">
            {scheduledQueue.length} {scheduledQueue.length === 1 ? "mensaje" : "mensajes"} en cola
          </Typography>
          <TextField
            fullWidth
            label={i18n.t("scheduledMessages.pick_datetime")}
            type="datetime-local"
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={scheduledFor}
            onChange={e => setScheduledFor(e.target.value)}
            inputProps={{ min: (() => {
              // datetime-local interprets value/min as LOCAL time (not UTC).
              // Build "YYYY-MM-DDTHH:MM" from local clock.
              const d = new Date(Date.now() + 60_000);
              const pad = n => String(n).padStart(2, "0");
              return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
            })() }}
          />
          <FormControlLabel
            label={<Typography variant="body2">{i18n.t("scheduledMessages.send_anyway_label")}</Typography>}
            control={
              <Switch
                size="small"
                checked={!scheduleCancelOnReply}
                onChange={e => setScheduleCancelOnReply(!e.target.checked)}
                color="primary"
              />
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setScheduleDialogOpen(false)} color="default">
            {i18n.t("scheduledMessages.cancel")}
          </Button>
          <Button onClick={handleScheduledSend} color="primary" variant="contained" disabled={loading || !scheduledFor}>
            {i18n.t("scheduledMessages.mode_button")}
          </Button>
        </DialogActions>
      </Dialog>
      </>
    );
  }
};

export default MessageInput;
